import { render, staticRenderFns } from "./sec_password.vue?vue&type=template&id=8506ff1a&"
import script from "./sec_password.vue?vue&type=script&lang=js&"
export * from "./sec_password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports